import { render } from "./CategoryFourFileUploadDialog.vue?vue&type=template&id=5d79067f&scoped=true"
import script from "./CategoryFourFileUploadDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryFourFileUploadDialog.vue?vue&type=script&lang=ts"

import "./CategoryFourFileUploadDialog.vue?vue&type=style&index=0&id=5d79067f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d79067f"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
